'use client'
import { useEffect, useState } from 'react'

export const useLifecycle = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
    setIsLoaded(true)
  }, [])

  return {
    isLoaded,
  }
}
